
























import Vue from 'vue';

export default Vue.extend({
  components: {
  },
  data() {
    return {
    };
  },
  computed: {
    hideTaxReductionInfo(): boolean {
      return this.$store.state.hideTaxReductionInfo
    },
  }
});
